import React, { ReactNode } from 'react';
import { Text, Flex } from '@televet/kibble-ui';

type FormAnswerProps = { question: string; children?: ReactNode; small?: boolean; };

export const FormAnswer = ({ question, children, small }: FormAnswerProps): JSX.Element => {
  const marginTop = small ? '16px' : '24px';
  return (
    <Flex
      direction="column"
      css={`
        & + & {
          margin-top: ${marginTop};
        }
      `}
    >
      <Text as="p" data-testid="widget-request-message-question" size={small ? 'sm' : undefined}>
        {question}
      </Text>
      <Text as="div" fontWeight="bold" data-testid="widget-request-message-answer" size={small ? 'sm' : undefined}>
        {children}
      </Text>
    </Flex>
  );
};
